import React from 'react';
import { SiteVariablesPrepared } from '@fluentui/react-northstar';
import { IChartData } from '../ChartTypes';
import { BaseChart } from './BaseChart';

export const LineStackedChart = ({ title, data,siteVariables }: { title: string; data: IChartData; siteVariables: SiteVariablesPrepared; }) => {
  return <BaseChart chartType='line' stacked={true} title={title} data={data} siteVariables={siteVariables} />;
};
